import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	releaseNotesButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	releaseNotesButton: {
		id: 'software-releases-version-detail.header.release-notes-button.release-notes-button',
		defaultMessage: 'Release notes',
		description: 'Release notes button label',
	},
});
export default messages;
